export const GET_FUNCIONAL_STRUCTURE = 'GET_FUNCIONAL_STRUCTURE';
export const LOADING_FUNCIONAL_STRUCTURE = 'LOADING_FUNCIONAL_STRUCTURE';